module.exports = __webpack_public_path__ + "static/images/fd823709ec42cfa7703c36b08868e556.png";